import React from 'react';
import { PRIVACY_URL, CS_URL } from '../constants';

const footerStyle = {
    height: '100px',
    lineHeight: '14px',
    padding: '20px 0',
    clear: 'both',
    background: '#eeeeee',
    color: '#999999',
    fontSize: '13px',
    // lineHeight: '64px',
    fontWeight: '100',
    marginTop: '80px',
    position: 'absolute',
    left: '0px',
    right: '0px',
    bottom: '0px'
};

const link_a_style = {
    padding: '0 5px',
    color: '#6bb324',
    cursor: 'pointer'
}

const link_a2_style = {
    padding: '0 5px',
    borderLeft: '1px solid #ccc',
    color: '#6bb324',
    cursor: 'pointer'
}

function footer() {
    return (
        <div style={footerStyle}>
            <div className="container">
                <div style={{ float: 'none', textAlign: 'center' }}>
                    <a style={link_a_style} rel="noopener noreferrer" href={CS_URL} target="_blank">客服中心</a>
                    <a style={link_a2_style} rel="noopener noreferrer" href={PRIVACY_URL} target="_blank">隱私權政策</a>
                </div>
                <div className="copyrightL" style={{ float: 'none', textAlign: 'center', marginTop: '10px' }}>Copyright © 2017 Net Publishing</div>
                <div className="copyrightR" style={{ float: 'none', textAlign: 'center' }}>隆中網絡股份有限公司保留一切權利</div>
            </div>
        </div>
    );
}

export default footer;




// WEBPACK FOOTER //
// ./src/components/footer.jsx